/**
 * Shared query-string builder for the /question-list endpoint.
 *
 * All three apps (admin, teacher, student) call the same backend endpoint
 * with the same filter schema. The server (see questionQueryBuilder.ts)
 * owns the allow-list of accepted fields, so clients should simply pass
 * through whatever filters they are given — no client-side allow-list.
 *
 * Accepts any string/number/boolean value. `undefined`, `null`, and empty
 * strings are skipped. Booleans are stringified ("true"/"false").
 */
export type QuestionListQueryFilters = Record<string, string | number | boolean | undefined | null>;

export function buildQuestionListQuery(filters?: QuestionListQueryFilters): string {
  const params = new URLSearchParams();
  if (!filters) return '';
  for (const [key, value] of Object.entries(filters)) {
    if (value === undefined || value === null || value === '') continue;
    params.append(key, String(value));
  }
  return params.toString();
}
